const ArrowDown = ({ ...props }) => {
  return (
    <svg
      width="91"
      height="101"
      viewBox="0 0 91 101"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.5615 4.38477L45.5615 91.2478"
        stroke="black"
        strokeWidth="7"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M85.374 55.5703L45.5618 95.3825L5.7496 55.5703"
        stroke="black"
        strokeWidth="7"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default ArrowDown
